import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import { ProDefinicionesService } from '@p-p-portafolio/services/pro-definiciones.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { UserService } from '@pages/user/services/user.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DefinicionesFormComponent } from '../definiciones-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SessionService } from '@shared/helpers/sesion.service';

@Component({
  selector: 'app-def-cargos-pagos',
  templateUrl: './def-cargos-pagos.component.html',
  styleUrls: ['./def-cargos-pagos.component.css']
})
export class DefCargosPagosComponent implements OnInit {
  @Input() modelRecived: ProDefiniciones;
  private _user: string = this._userServices.userCurrent;
  public promocion: string = localStorage.getItem('prom');
  public breakpoint: number;
  public tasas: any[];
  public conceptos: any[];
  public calculate: any[];
  public aplicateTo: any[];
  public calculate2: any[];
  public solicitudesValores: any[] = [];
  public formPrincipal: boolean = true;
  public selectTasa: boolean;
  public selectCocepto: boolean;
  public selectCocepto2: boolean;
  public loading: boolean;

  constructor(
    private _fb: FormBuilder,
    private _dialogRef: MatDialogRef<DefinicionesFormComponent>,
    private _swalService: SwalService,
    private _proDefServices: ProDefinicionesService,
    private _userServices: UserService,
    private _injectServices: InjectableService,
    private _tasasServices: TasasService,
    private _conceptosServices: ConceptosService,
    private renderer: Renderer2,
    private _snackBar: MatSnackBar,
    private el: ElementRef,
    private _sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.readCalculate();
    this.readAplicateTo();
    this.readCalculate2();
    this.readSolicitudesValores();
    this.setForm();
    this.readConceptos();
    this.injectConcepto();
    this.readTasas();
    this.injectTasa();
    this.onBreakPonit();
  }

  form = this._fb.group({
    promocion: [this.promocion],
    numVar: [
      '',
      {
        validators: [Validators.required, this.variableValidation()],
        asyncValidators: [this.singleDefinicion()],
        updateOn: 'blur'
      }
    ],
    descripcion: ['', Validators.required],
    claveTasa: [''],
    valorFijo: [0],
    amortInf: [0],
    amortSup: [0],
    formula: [''],
    porcentaje: [0, Validators.required],
    concepto: [0, Validators.required],
    conceptoAdicional: [0],
    user: this._user,
    // Valores que van en formula
    calculate: [1],
    calculate2: [1],
    aplicateTo: [1]
  });

  readCalculate() {
    let iTipo: number = 45;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.calculate = res.data;
    });
  }

  readAplicateTo() {
    let iTipo: number = 21;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.aplicateTo = res.data;
    });
  }

  readCalculate2() {
    let iTipo: number = 22;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.calculate2 = res.data;
    });
  }

  readSolicitudesValores() {
    this.loading = true;
    this._proDefServices.getSolicitudesValores(this._sessionService.getUserSession()).subscribe({
      next: (res) => {
        if (res.success) {
          this.solicitudesValores = res.data || [];
          // Al editar, precargar "Calcular" con el mismo tipo que las opciones para que el select muestre la selección
          if (this.modelRecived && this.solicitudesValores.length) {
            const valorFijo = this.modelRecived.valorFijo;
            const item = this.solicitudesValores.find((s: any) => s.iValor == valorFijo || Number(s.iValor) === Number(valorFijo));
            this.form.patchValue({
              calculate: item ? item.iValor : (valorFijo ?? this.form.get('calculate')?.value)
            });
          }
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar valores de solicitudes:', err);
        this._swalService.error('Error al cargar valores de solicitudes');
        this.loading = false;
      }
    });
  }

  readConceptos() {
    this._conceptosServices.getAll().subscribe((res) => {
      this.conceptos = res;
    });
  }

  injectConcepto() {
    this._injectServices.disparadorConcepto.subscribe((res) => {
      if (this.selectCocepto2) this.form.patchValue({ conceptoAdicional: res.model.data });
      else this.form.patchValue({ concepto: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  readTasas() {
    this._tasasServices.read().subscribe((res) => {
      this.tasas = res.data;
    });
  }

  injectTasa() {
    this._injectServices.disparadorTasas.subscribe((res) => {
      this.form.patchValue({ claveTasa: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  changeBoolean(change: string) {
    switch (change) {
      case 'form':
        this.selectCocepto = false;
        this.selectCocepto2 = false;
        this.selectTasa = false;
        this.formPrincipal = true;
        break;
      case 'conceptos':
        this.formPrincipal = false;
        this.selectCocepto = true;
        break;
      case 'tasas':
        this.formPrincipal = false;
        this.selectTasa = true;
        break;
      case 'conceptos2':
        this.formPrincipal = false;
        this.selectCocepto = true;
        this.selectCocepto2 = true;
        break;
    }
  }

  create(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      const payload = {
        ...model,
        valorFijo: this.toNumber(model.calculate),
        conceptoAdicional: this.toNumber(model.conceptoAdicional)
      };
      this._proDefServices.create(payload).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
      });
    } else {
      console.log(this.form.value);
      this._snackBar.open('Debe diligenciar todos los campos correctamente', 'cerrar', { duration: 5000 });
    }
  }

  update(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      const payload = {
        ...model,
        valorFijo: this.toNumber(model.calculate),
        conceptoAdicional: this.toNumber(model.conceptoAdicional)
      };
      this._proDefServices.update(payload).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    } else {
      console.log(this.form.value);
      this._snackBar.open('Debe diligenciar todos los campos correctamente', 'cerrar', { duration: 5000 });
    }
  }

  formValue(value: string) {
    return this.form.get(value);
  }

  private toNumber(value: any): number {
    if (value === '' || value === null || value === undefined) return 0;
    const n = Number(value);
    return isNaN(n) ? 0 : n;
  }

  //#region Validations
  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const variable = control.value;
      if (variable == null || variable === '') return null;
      if (variable >= 601 && variable <= 700) {
        return null;
      }

      this._snackBar.open('El rango de variables para Cargos Pagos es de 601 a 700', 'cerrar', { duration: 5000 });
      const input = this.el.nativeElement.querySelector('#numVar');
      if (input) {
        this.renderer.addClass(input, 'is-invalid');
      }

      return { variableValidation: true };
    };
  }

  //#endregion

  //#region AsyncValidations
  singleDefinicion(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | any> => {
      if (this.modelRecived) return of(null);

      return this._proDefServices.readOne(this.promocion, control.value).pipe(
        tap(() => {
          const input = this.el.nativeElement.querySelector('#numVar');
          this.renderer.removeClass(input, 'is-invalid');
        }),
        map((res) => {
          const input = this.el.nativeElement.querySelector('#numVar');
          // 1 → la promoción no existe  ⇒  VÁLIDA
          if (res.exito === 1) {
            this.renderer.addClass(input, 'is-invalid'); // aura roja
            this._snackBar.open('Variable en uso, intente con otra.', 'cerrar', { duration: 5000 });
            return { singleDefinicion: true }; // ← objeto de error
          }
          // distinto de 1 → libre  ⇒  INVÁLIDA
          return null; // ← sin errores
        })
      );
    };
  }
  //#endregion

  setFormula(): string {
    let sep = '|';
    let calculate2 = this.form?.controls.calculate2.value;
    let porcentaje = this.form?.controls.porcentaje.value;
    let descripcion = this.form?.controls.descripcion.value;
    let conceptoAdicional = this.form?.controls.conceptoAdicional.value;
    let lst = sep + descripcion + sep + calculate2 + sep + porcentaje + sep + descripcion + sep + conceptoAdicional + sep;
    return lst;
  }

  getFormula(formula: string): void {
    if (!formula || typeof formula !== 'string') return;
    const formulaSep: string[] = formula.split('|');
    // Solo parsear si es el formato con pipes (varios segmentos); si es fórmula libre (ej. TOB(...)) no sobrescribir
    if (formulaSep.length < 3) return;
    const n0 = Number(formulaSep[0]);
    const n1 = Number(formulaSep[1]);
    const n2 = Number(formulaSep[2]);
    if (isNaN(n0) || isNaN(n1) || isNaN(n2)) return;
    this.form.patchValue({
      calculate: n0,
      aplicateTo: n1,
      calculate2: n2
    });
  }

  setForm(): void {
    if (this.modelRecived !== null) {
      console.log(this.modelRecived);
      let model: ProDefiniciones = this.modelRecived;
      this.getFormula(model.formula);
      const setModel = {
        promocion: model.promocion,
        numVar: model.numVar.toString(),
        descripcion: model.descripcion,
        claveTasa: model.claveTasa,
        calculate: model.valorFijo,
        amortInf: 0,
        amortSup: 0,
        formula: model.formula,
        porcentaje: model.porcentaje,
        concepto: model.concepto,
        conceptoAdicional: model.conceptoAdicional,
        user: this._user
      };
      this.form.patchValue(setModel);
    }
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }
}
